export default __webpack_public_path__ + "locales/cs/UploadPanel.json?hash=4ca8f2d3d0edff94f9cda13cbff29906";